import React from 'react';
import Modal from '../../../../components/modal';
import { Desktop, Mobile } from '../../../../app-responsive';
import { customStylesDesktop, customStylesMobile } from '../../../../components/business-case-delete-modal/modal-styles-config';
import { stripStartingAndEndingPTags } from '../../ssm-homepage.actions';
import PopupHeader from '../popup-header/popup-header';

const AlreadySubmittedModal = (props) => {
  const {
    modalIsOpen,
    onCloseDialogBox,
    authorableContent,
  } = props;
  const desktopModalStyles = { content: { ...customStylesDesktop.content, width: '50%' } };

  const {
    alreadySubmittedTitle,
    alreadySubmittedDescription,
  } = authorableContent;

  const modalContent = customStyles => (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onCloseDialogBox}
      style={customStyles}
    >
      <div className="already-submitted-modal">
        <PopupHeader
          PopTitle={alreadySubmittedTitle}
          PopupText={stripStartingAndEndingPTags(alreadySubmittedDescription)}
          textCenter
        />
      </div>
    </Modal>
  );

  return (
    <React.Fragment>
      <Mobile>
        {modalContent(customStylesMobile)}
      </Mobile>
      <Desktop>
        {modalContent(desktopModalStyles)}
      </Desktop>
    </React.Fragment>
  );
};

export default AlreadySubmittedModal;
